const checkPngTransparency = (arrayBuffer, buffer) => {
  const colorType = buffer[25];

  // Color types: 4 = Grayscale+alpha, 6 = RGB+alpha
  if (colorType === 4 || colorType === 6) {
    return true;
  }

  // Color type 3 = indexed color, check for tRNS (transparency) chunk
  if (colorType === 3) {
    const view = new DataView(arrayBuffer);
    let offset = 33; // Start after IHDR chunk

    while (offset < buffer.length - 8 && offset <= 1000) {
      const chunkLength = view.getUint32(offset);
      const chunkType = String.fromCharCode(...buffer.slice(offset + 4, offset + 8));

      if (chunkType === 'tRNS') return true;
      if (chunkType === 'IDAT') break;

      offset += 12 + chunkLength;
    }
  }

  return false;
};

const checkWebpTransparency = (buffer) => {
  // Scan chunks after 12-byte RIFF header. Chunks: 4-byte id + 4-byte size (LE) + data
  const VP8X_ID = [0x56, 0x50, 0x38, 0x58]; // "VP8X"
  const view = new DataView(buffer.buffer, buffer.byteOffset, buffer.byteLength);
  let offset = 12;

  while (offset + 8 <= buffer.length) {
    const chunkId = buffer.slice(offset, offset + 4);
    const chunkSize = view.getUint32(offset + 4, true);

    if (VP8X_ID.every((byte, i) => chunkId[i] === byte)) {
      // VP8X data: byte 0 = flags, bit 4 (0x10) = alpha
      const flags = buffer[offset + 8];
      return Math.floor(flags / 16) % 2 === 1;
    }

    offset += 8 + chunkSize;
  }

  return false;
};

// eslint-disable-next-line import/prefer-default-export
export const hasTransparentBackground = async (file) => {
  try {
    const arrayBuffer = await file.arrayBuffer();
    const buffer = new Uint8Array(arrayBuffer);

    // PNG signature
    const PNG_SIGNATURE = [0x89, 0x50, 0x4E, 0x47, 0x0D, 0x0A, 0x1A, 0x0A];
    if (PNG_SIGNATURE.every((byte, i) => buffer[i] === byte)) {
      return checkPngTransparency(arrayBuffer, buffer);
    }

    // WebP signature: RIFF....WEBP
    const RIFF = [0x52, 0x49, 0x46, 0x46];
    const WEBP = [0x57, 0x45, 0x42, 0x50];
    if (
      RIFF.every((byte, i) => buffer[i] === byte)
      && WEBP.every((byte, i) => buffer[i + 8] === byte)
    ) {
      return checkWebpTransparency(buffer);
    }

    throw new Error('Not a valid PNG or WebP file');
  } catch (err) {
    throw new Error(`Failed to read file: ${err.message}`);
  }
};
